import { render, staticRenderFns } from "./BindPersonnel.vue?vue&type=template&id=29838d3e&"
import script from "./BindPersonnel.vue?vue&type=script&lang=js&"
export * from "./BindPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports